/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { createUseStyles } from 'react-jss'
import { QRCodeSVG as QRCode } from 'qrcode.react'
import {
  useSystemSettings,
  useUser,
} from '../../vendor/react-omnitech-api'
import useLink from '../use-link/use-link'
import isUserProfileComplete from '../../helpers/is-user-profile-complete'
import useModal from '../use-modal/use-modal'
import useThemeConfig from '../use-theme-config/use-theme-config'

export default function MemberQrCodeModalHook() {
  const { navigate } = useLink()
  const { getSystemSetting } = useSystemSettings()
  const { t } = useTranslation()
  const { getConfig } = useThemeConfig()
  const {
    user,
  } = useUser()
  const modal = useModal()
  const useStyles = createUseStyles(() => ({
    logos: {
      justifyContent: 'center',
    },
  }))
  const styles = useStyles()
  const open = () => {
    const memberShipCode = _.get(user, 'membershipCode')
    const qrCode = _.get(user, 'qrCodeValue')
    const userEditProfileFieldsConfig = getSystemSetting('account.user_edit_profile_fields')
    const enableInfoButton = getConfig('config.ui.memberCodeModal.infoButton.enable', true)
    const enableUserProfileCheck = getConfig('config.enableUserProfileCheck', false)
    const infoPageSlug = getConfig('config.ui.memberCodeModal.infoButton.pageSlug', 'membership')
    // check user profile first
    if (
      isUserProfileComplete({
        user,
        config: userEditProfileFieldsConfig,
      }) || !enableUserProfileCheck
    ) {
      modal.open({
        title: t('ui.memberModal.title'),
        contentComponent: (
          <>
            <QRCode
              value={qrCode}
              size={170}
            />
            {
              !_.isEmpty(memberShipCode) && (
                <p className={styles.memberNumber}>{memberShipCode}</p>
              )
            }
            <p className={styles.dialogDescription}>{t('ui.memberModal.info')}</p>
          </>
        ),
        buttons: [
          {
            text: t('ui.memberModal.buttons.close'),
            onClick: () => modal.close(),
          },
        ],
        ...(
          enableInfoButton ? {
            infoButton: {
              to: `/pages/${infoPageSlug}`,
              onClick: () => {
                modal.close()
              },
            },
          } : {}
        ),
      })
    } else {
      modal.open({
        title: t('ui.incompleteUserProfileModal.title'),
        message: t('ui.incompleteUserProfileModal.description'),
        buttons: [
          {
            text: t('ui.incompleteUserProfileModal.buttons.editProfile'),
            onClick: () => {
              modal.close()
              navigate('/account/profile/')
            },
          },
          {
            text: t('ui.incompleteUserProfileModal.buttons.cancel'),
            onClick: () => modal.close(),
          },
        ],
      })
    }
  }

  return {
    open,
    close: modal.close,
  }
}
